import { styled } from "@linaria/react"


import { Horizontal, Vertical } from "@/components/Flex.ts"
import { mobileBreakpoint } from "@/styles/mixins.ts"

import type { Property } from "csstype"

export const PageContainer = styled(Horizontal)`
  position: relative;

  width: 100%;
  height: 100%;
  min-height: 100vh;
`

export const PageBackground = styled.div<{
  background?: Property.Background
}>`
  position: fixed;
  inset: 0;

  background: ${props => props.background ?? "transparent"};

  pointer-events: none;
  z-index: -1;
`

export const PageContent = styled(Vertical)<{
  twoPaneLayout: boolean
}>`
  flex-grow: 1;

  padding: ${props => props.twoPaneLayout ? `0 0 0 ${PAGE_HORIZONTAL_PADDING}` : `16px ${PAGE_HORIZONTAL_PADDING}`};

  @media ${mobileBreakpoint} {
    padding: ${props => props.twoPaneLayout ? `0 0 0 ${PAGE_HORIZONTAL_PADDING_MOBILE}` : `16px ${PAGE_HORIZONTAL_PADDING_MOBILE}`};
  }
`

export const PAGE_HORIZONTAL_PADDING = "88px"
export const PAGE_HORIZONTAL_PADDING_MOBILE = "72px"